import React from 'react'
import moment from 'moment'
import cn from 'classnames'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import AddToFavorites from 'app/domains/common/AddToFavorites/AddToFavorites'

import './styles.scss'

const bc = 'favorite-activity-header'

const headerContent = (type, name, t) => {
  switch (type) {
    case 'did':
      return t('Finished', { name })
    case 'commit':
      return t('Committed', { name })
    default:
      return t('Skipped', { name })
  }
}

export const FavoriteActivityHeader = ({
  t,
  favoriteActivity: { activityId, createdAt, name, isFavorite, proTrackName, levelName },
  actionType,
  removeFromFavorites,
  addToFavorites,
  isCompletedActivityBlock,
}) => (
  <div className={bc}>
    {isCompletedActivityBlock ? (
      <div className={cn(`${bc}__completed-activity`)}>{headerContent(actionType, name, t)}</div>
    ) : (
      <div className={`${bc}__left-part`}>
        <div className={`${bc}__text ${bc}__text--activity-name`}>{name}</div>
        <div className={`${bc}__text ${bc}__text--protrack-name`}>{`${proTrackName} (${levelName})`}</div>
        <div className={`${bc}__text ${bc}__text--timestamp`}>{moment(createdAt).format('MM-DD-YY')}</div>
      </div>
    )}
    <div className={`${bc}__right-part`}>
      {!isCompletedActivityBlock && (
        <AddToFavorites
          activityId={activityId}
          title={isFavorite ? t('Remove from favorites') : 'Add to favorites'}
          addToFavorites={addToFavorites}
          removeFromFavorites={removeFromFavorites}
          highlightFavoriteIcon={isFavorite}
          showText={false}
        />
      )}
    </div>
  </div>
)

FavoriteActivityHeader.propTypes = {
  favoriteActivity: PropTypes.object.isRequired,
  actionType: PropTypes.string,
  removeFromFavorites: PropTypes.func,
  addToFavorites: PropTypes.func,
}

FavoriteActivityHeader.displayName = 'FavoriteActivityHeader'

export default withTranslation('user')(FavoriteActivityHeader)
